/**
 * Названия динамических частей адресов страниц.
 *
 * Вынесено в отдельный модуль из app/routes/special/otherRoutes, потому что
 * перечисление используется в листовых модулях по всему приложению, а импорт
 * из otherRoutes тянул за собой все компоненты страниц в главный бандл.
 */
export enum RouterVarNames {
	SchoolId = 'schoolId',
	TrainingId = 'trainingId',
	LessonId = 'lessonId',
	ExerciseId = 'exerciseId',
	StudentId = 'studentId',
	GroupId = 'groupId',
	EmployeeId = 'employeeId',
	DeleteAccountCode = 'deleteAccountCode',
	NewsId = 'newsId',
}
